export default __webpack_public_path__ + "static/top-89fe7465537722b878b2dc2bdddc118d.jpg";